<div class="flex-direction-column page">
  @if (usuarioComPermissao) {
    <div class="flex gap-20 wrap">
      <!-- CANAIS -->
      @if ((!isCelular && !isTablet)
        || (isCelular && !canalIdSelecionado && !operadorSelecionado)
        || (isTablet && !contatoSelecionado)) {
        <div class="flex-direction-column gap-15 container-cards" style="overflow-y: auto" [style.width]="isTablet || isCelular ? '100%' : '550px'"
             [style.height]="isTablet || isCelular ? '85vh' : '90vh'" [style.padding]="'15px 0 0 0'" [style.max-width]="isTablet ? '46%' : ''">
          <div [style.margin-left]="'15px'">
            <span class="titulo-card">Canais</span>
          </div>
          @for (canalOperador of canaisOperadores; track canalOperador.idCanal) {
            <app-info-cainais-operadores [canaisOperadores]="canalOperador" [isMobile]="isCelular || isTablet"
              (operadorEscolhido)="receberCanalOperadorEscolhido($event)"></app-info-cainais-operadores>
          }
        </div>
      }

      <!-- FILA -->
      @if ((!isCelular && !isTablet)
        || (isCelular && canalIdSelecionado && operadorSelecionado)
        || (isTablet && canalIdSelecionado && operadorSelecionado)) {
        <div class="container-cards" style="overflow-y: auto" [style.width]="isTablet || isCelular ? '100%' : '413px'"
             [style.height]="isTablet || isCelular ? '85vh' : '90vh'" [style.padding]="'15px 10px 0 10px'" [style.max-width]="isTablet ? '46%' : ''"
             #scrollableFila (scroll)="onScrollFila()">
          <div class="margin-bottom-10 flex-direction-row justify-between align-center">
            <span class="titulo-card">Fila</span>
            <app-button-padrao
              class="botao-filtro-fila-espera"
              iconSrc="icones/filtros"
              iconSrcExtensao=".svg"
              width="36px"
              height="36px"
              backgroundColor="#993DF5"
              widthIcon="26px"
              heightIcon="26px"
              matTooltip="Filtrar"
              (buttonClick)="abrirModalFiltro()">
            </app-button-padrao>
            @if (isCelular || isTablet) {
              <img class="cursor-pointer" src="./assets/icones/xmark-retangulo%202-black.svg" style="transform: scale(1.5);" (click)="contatoSelecionado = sessaoContatoSelecionado = canalIdSelecionado = operadorSelecionado = undefined"
                   (keydown.enter)="contatoSelecionado = sessaoContatoSelecionado = canalIdSelecionado = operadorSelecionado = undefined" tabindex="0" role="button" alt="Fechar" />
            }
          </div>
          <div class="flex-direction-column gap-10">
            @if (buscandoFila && showSkeleton) {
              @for (linha of linhasSkeleton; track linha) {
                <div class="card-fila-skeleton flex-direction-column gap-5">
                  <div class="flex gap-5 justify-between">
                    <div class="flex gap-5">
                      <div class="skeleton" style="width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;"></div>
                      <div class="flex-direction-column gap-5">
                        <div class="skeleton" style="width: 90px; height: 10px;"></div>
                        <div class="skeleton" style="width: 70px; height: 10px;"></div>
                        <div class="skeleton" style="width: 110px; height: 10px;"></div>
                      </div>
                    </div>
                    <div class="flex-direction-column gap-5" style="align-items: flex-end;">
                      <div class="skeleton" style="width: 80px; height: 16px;"></div>
                      <div class="skeleton" style="width: 60px; height: 10px;"></div>
                      <div class="skeleton" style="width: 60px; height: 10px;"></div>
                    </div>
                  </div>
                  <div class="flex gap-5">
                    <div class="skeleton" style="width: 77px; height: 22px; border-radius: 15px;"></div>
                    <div class="skeleton" style="width: 77px; height: 22px; border-radius: 15px;"></div>
                  </div>
                </div>
              }
            } @else if (!buscandoFila && fila.length > 0) {
              @for (fil of fila; track fil.idSessao) {
                <div>
                  <app-card-fila-contato-sessao (cardSelecionado)="receberSessaoContatoEscolhido($event)"
                                                [fila]="fil"></app-card-fila-contato-sessao>
                </div>
              }
            } @else if (!buscandoFila) {
              <div class="flex center-center" style="padding-top: 40px;">
                <app-balao-informativo
                  [titulo]="'Fila vazia'"
                  [texto]="'Não há contatos aguardando atendimento neste canal.'"
                  [width]="'249px'"
                  [heigth]="'122px'">
                </app-balao-informativo>
              </div>
            }

            @if (isLoading) {
              @for (linha of [1, 2]; track linha) {
                <div class="card-fila-skeleton flex-direction-column gap-5">
                  <div class="flex gap-5">
                    <div class="skeleton" style="width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;"></div>
                    <div class="flex-direction-column gap-5">
                      <div class="skeleton" style="width: 90px; height: 10px;"></div>
                      <div class="skeleton" style="width: 70px; height: 10px;"></div>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }

      <!-- CHAT -->
      @if (!isCelular && (!isTablet || (isTablet && contatoSelecionado))) {
        <div class="container-cards" [style.width]="isTablet || isCelular ? '100%' : '38vw'"
             [style.height]="isTablet || isCelular ? '85vh' : '92vh'" [style.max-width]="isTablet ? '46%' : ''">
          @if (contatoSelecionado){
            <div class="flex center-center container-chat">
              <app-chat-conversa class="width-100 fila-chat" [contato]="contatoSelecionado"></app-chat-conversa>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="flex gap-10 align-center">
      <img src="assets/icones/advertencia.svg" alt="Advertência">
      <span class="font-12 weight-600">Para acessar é necessário ser Coordenador</span>
    </div>
  }
</div>
